<template>

  <!-- Desktop -->
  <div class="form__bloc">
    <div class="gridWrapper">
      <!-- Header -->
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-5">
          <span>Stagiaire</span>
        </div>
        <div class="elem elem--span-7">
          <span>Nature de frais</span>
        </div>
        <div class="elem elem--span-4">
          <span>Demandé</span>
        </div>
        <div class="elem elem--span-4">
          <span>Montant accordé (HT)</span>
        </div>
        <div class="elem elem--span-4">
          <span>Demande de remboursement (HT)</span>
        </div>
        <div class="elem elem--span-4">
          <span>Montant réglé (HT)</span>
        </div>
        <div class="elem elem--span-4">
          <span>Taux TVA</span>
        </div>
        <div class="elem elem--span-3">
          <span>Total TTC</span>
        </div>
        <div
          class="elem elem--span-1"
          style="width: 36px"
        ></div>
      </div>
      <!-- Lignes frais -->
      <div
        v-for="item in frais"
        :key="`${item.idModule}_${item.idSalarie}`"
        class="gridElemWrapper"
      >
        <div class="cardLayoutWrapper">
          <!-- Nom Prenom stagiaire -->
          <div class="elem elem--span-5">
            <span>{{ item.prenom }} {{ item.nom }}</span>
          </div>
          <!-- natureFrais -->
          <div class="elem elem--span-7">
            <BasicText
              :label="getNatureFraisLabel(item)"
              style="font-size: 14px; font-weight: bold" />
          </div>
          <!-- montantDemande -->
          <div class="elem elem--span-4">
            <WrapperInput
              :model-value="financementDemandeFormatter(item)"
              separateur
              disabled
            />
          </div>
          <!-- montantEngage -->
          <div class="elem elem--span-4">
            <WrapperInputNumber
              :model-value="item.montantEngage"
              :decimal="2"
              separateur
              disabled
            />
          </div>
          <!-- MontantDemandeRemboursement -->
          <div class="elem elem--span-4">
            <WrapperInputNumber
              v-if="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$status !== PropertyStatus.NotPresent"
              :model-value="item.montantDemandeRemboursement"
              @update:model-value="updateFrais('montantDemandeRemboursement', item.index, $event)"
              :required="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$status === PropertyStatus.Required"
              :readonly
              :alert-label="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$messageErreurDirty"
              :placeholder="PLACEHOLDER_MONTANT"
              separateur
              deletable
              input-type="table"
            />
            <WrapperInputNumber
              v-else
              :placeholder="PLACEHOLDER_MONTANT"
              disabled
            />
          </div>
          <!-- montantRegle -->
          <div class="elem elem--span-4">
            <WrapperInputNumber
              :model-value="item.montantRegle"
              :decimal="2"
              separateur
              disabled
            />
          </div>
          <!-- tauxTva -->
          <div class="elem elem--span-4">
            <WrapperDropdown
              v-if="meta.frais?.at(item.index)?.tauxTva?.$status !== PropertyStatus.NotPresent"
              :items="tauxTva"
              :model-value="item.tauxTva"
              @update:model-value="updateFrais('tauxTva', item.index, $event)"
              :required="meta.frais?.at(item.index)?.tauxTva?.$status === PropertyStatus.Required"
              :disabled="item.natureFrais === 'Remuneration'"
              :readonly
              :alert-label="meta.frais?.at(item.index)?.tauxTva?.$messageErreurDirty"
              placeholder="Taux TVA"
              dropdown-type="table"
            ></WrapperDropdown>
            <WrapperDropdown
              v-else
              disabled
              placeholder="Taux TVA"
              dropdown-type="table"
            ></WrapperDropdown>
          </div>
          <!-- Calcul Total TTC -->
          <div class="elem elem--span-3 elem--right">
            <BasicText>
              <span>{{ formatNumber(item.montantTTC, { decimal: 2 }) ?? '-' }}</span>
            </BasicText>
          </div>
          <!-- Bputon supprimer -->
          <div
            v-if="item.estSupprimable && estTraite && !readonly"
            class="elem elem--span-1 elem--right"
          >
            <BasicTooltip label="Supprimer la ligne de frais">
              <BasicIcon name="trash"  @click="deleteFrais(item)" :disabled="readonly"  />
            </BasicTooltip>
          </div>
          <div
            v-else
            class="elem elem--span-1"
            style="width: 36px"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <!-- Mobile -->
  <div class="block-mobile">
    <div
      v-for="item in frais"
      :key="`${item.idModule}_${item.idSalarie}`"
      class="card">
      <!-- Prénom Nom -->
      <div class="card__top" style="display: flex; justify-content: space-between; align-items: center; height: 73px;">
        <div class="card__top__text">
          <BasicText weight="bold">{{ item.prenom }} {{ item.nom }}</BasicText>
        </div>
        <div class="elem" v-if="item.estSupprimable && estTraite">
          <div class="elem--horizontal elem--horizontal--right">
            <BasicTooltip label="Supprimer">
              <BasicIcon name="trash" @click="deleteFrais(item)" :disabled="readonly" />
            </BasicTooltip>
          </div>
        </div>
      </div>
      <div class="card__section">
        <!-- Nature de frais -->
        <div class="elem">
          <BasicText
            :label="getNatureFraisLabel(item)"
            weight="bold"
            size="h5"
          />
        </div>
        <!-- montantDemande -->
        <div class="elem">
          <span>Demandé</span>
          <WrapperInput
            :model-value="financementDemandeFormatter(item)"
            :disabled="true"

          />
        </div>
        <!-- montantEngage -->
        <div class="elem">
          <span>Montant accordé (HT)</span>
          <WrapperInputNumber
            :model-value="item.montantEngage"
            :decimal="2"
            :disabled="true"
            separateur
          />
        </div>
        <!-- montantDemandeRemboursement -->
        <div class="elem">
          <span>Demande de remboursement (HT)</span>
          <WrapperInputNumber
            v-if="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$status !== PropertyStatus.NotPresent"
            :model-value="item.montantDemandeRemboursement"
            @update:model-value="updateFrais('montantDemandeRemboursement', item.index, $event)"
            :required="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$status === PropertyStatus.Required"
            :readonly
            :alert-label="meta.frais?.at(item.index)?.montantDemandeRemboursement?.$messageErreurDirty"
            :placeholder="PLACEHOLDER_MONTANT"
            separateur
            deletable
          />
          <WrapperInputNumber
            v-else
            :placeholder="PLACEHOLDER_MONTANT"
            disabled
          />
        </div>
        <!-- montantRegle -->
        <div class="elem">
          <span>Montant réglé (HT)</span>
          <WrapperInputNumber
            :model-value="item.montantRegle"
            :decimal="2"
            separateur
            :disabled="true"
          />
        </div>
        <!-- tauxTva -->
        <div class="elem">
          <span>Taux TVA</span>
          <WrapperDropdown
            v-if="meta.frais?.at(item.index)?.tauxTva?.$status !== PropertyStatus.NotPresent"
            :items="tauxTva"
            :model-value="item.tauxTva"
            @update:model-value="updateFrais('tauxTva', item.index, $event)"
            :required="meta.frais?.at(item.index)?.tauxTva?.$status === PropertyStatus.Required"
            :disabled="item.natureFrais === 'Remuneration'"
            :readonly
            :alert-label="meta.frais?.at(item.index)?.tauxTva?.$messageErreurDirty"
            placeholder="Taux TVA"
          ></WrapperDropdown>
          <WrapperDropdown
            v-else
            placeholder="Taux TVA"
            disabled
          ></WrapperDropdown>
        </div>
        <div class="elem--horizontal elem--horizontal--right">
          <span>Total TTC</span>
          <BasicText
            :label="formatNumber(item.montantTTC, { decimal: 2 }) ?? '-'"
            weight="bold"
            size="h5"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { FraisDTO } from '@/features/api/extranet/dto/Demande/DR'
import { PropertyStatus } from '@/features/domaine/property-status'
import { TauxTva } from '@/features/domaine/types/opco'
import { PLACEHOLDER_MONTANT } from '@/features/interface/demande/shared/language'
import { formatNumber, isNullOrUndefined } from '@/features/shared/tools'
import { computed } from 'vue'
import { useModuleFrais, type Frais } from '../../useModuleFrais'

  const props = defineProps<{
    moduleIndex: number
  }>()
  const state = useModuleFrais(props.moduleIndex)

  const estTraite = computed(() => model.value?.modules?.at(props.moduleIndex)?.estTraite)

  const { frais, model, meta, readonly, updateFrais, lov, deleteFrais } = state

  const getNatureFraisLabel = (frais: FraisDTO) =>
    lov.value.NatureFrais.find(n => n.code === frais.natureFrais)?.intitule ?? '<Nature frais inconnue>'

  const tauxTva = computed(() =>
    TauxTva.map(taux =>
      ({
        id: taux,
        label: formatNumber(taux, { decimal: 2, pourcentage: true }) + ' %',
      })
    )
  )

  const financementDemandeFormatter = (financement: Frais) => {

    switch (financement.typeMontantDemande) {
       case 'DureeHeure':
        return financement.montantDemande + ' heures'
      case 'DureeMois':
        return financement.montantDemande + ' mois'
      case 'Quantite':
        return financement.montantDemande + ' (quantité)'
      default :

         return isNullOrUndefined(financement.montantDemande) ? '' : formatNumber(financement.montantDemande, { decimal: 2, separateur: true }) + ' € (HT)'
    }
  }

</script>

<style lang="less" scoped>
  @import '../StagiaireSection.less';
</style>

